export default __webpack_public_path__ + "static/media/Lora-Regular.17e9dc52.ttf";